import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

import { MAKE_ROUTE_PATH } from '../components/shared/constants';

const BrandRoute = (
  <Route
    key="brand/:brand_slug"
    path={MAKE_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/brand_page'
      ).then(m => cb(null, m.default));
    }}
  />
);

export { BrandRoute };
